import React from "react";
import { SlotTooltipData } from "./types";

interface IProps {
  data: SlotTooltipData;
}

const TimeSlotTooltip: React.FC<IProps> = ({ data }) => {
  return (
    <div className="time-slot-tooltip">
      {/* <div>
        <strong>Kort:</strong> {data.contextName}
      </div> */}
      <div>
        <strong>Godzina:</strong> {data.timeRange}
      </div>
      <div>
        <strong>Czas trwania:</strong> {data.duration}
      </div>
      <div>
        <strong>Status:</strong> {data.status}
      </div>
      {data.occupancy && (
        <div>
          <strong>Zajęte miejsca:</strong> {data.occupancy}
        </div>
      )}
    </div>
  );
};

export default TimeSlotTooltip;
